module.exports = __webpack_public_path__ + "img/c599407.png";